import { useEffect, useMemo } from 'react';

import { useSignOrder as useSignOrderApi } from 'api/requests';
import { OrderEntity } from 'api/types/entity';
import { ErrorCode } from 'api/types/error';
import { useNotify } from 'libs/notify';

import { SignOrderFormErrors, SignOrderFormType } from '../forms/signOrderForm';

interface UseSignOrderArgs {
  order: OrderEntity;
  startDate?: Date;
  executionPeriodInBusinessDays?: number;
}

export const useSignOrder = ({
  order,
  startDate,
  executionPeriodInBusinessDays,
}: UseSignOrderArgs) => {
  const notify = useNotify();

  const { error: signError, signOrder } = useSignOrderApi();

  const signFormError = useMemo<SignOrderFormErrors>(() => {
    if (signError?.code === ErrorCode.INVALID_OTP_TOKEN) {
      return { otpCode: signError.message };
    }
    return {};
  }, [signError]);

  const onSign = async (values: SignOrderFormType) => {
    await signOrder(order.id, {
      otpCode: values.otpCode,
      versionNumber: order.versionNumber ?? 0,
      startDate: !order.startDate ? startDate : undefined,
      executionPeriodInBusinessDays:
        order.executionPeriodInBusinessDays === undefined
          ? executionPeriodInBusinessDays
          : undefined,
    });
  };

  useEffect(() => {
    if (signError && signError.code !== ErrorCode.INVALID_OTP_TOKEN) {
      notify.error(signError);
    }
  }, [notify, signError]);

  return { signFormError, onSign };
};
